module.exports = "/static/assets/0aed289656b9305b500b0e3efe867a5a.png";